import { render, staticRenderFns } from "./ResellerDashboard.vue?vue&type=template&id=45b09021&scoped=true&"
import script from "./ResellerDashboard.vue?vue&type=script&lang=js&"
export * from "./ResellerDashboard.vue?vue&type=script&lang=js&"
import style0 from "./ResellerDashboard.vue?vue&type=style&index=0&id=45b09021&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b09021",
  null
  
)

component.options.__file = "ResellerDashboard.vue"
export default component.exports